import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Keyboard, View } from 'react-native';
import Text from 'design-system/Text';
import { Button, rem, Spacer } from 'design-system';
import { IconArrow, IconBank } from 'design-system/icons';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectHasValidGBAccounts } from 'reducers/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import SelectFundingAccountModal from './SelectFundingAccountModal';
const FundingAccountRow = ({ setFrom, scrollValue, onScroll }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const hasValidGBAccounts = useAppSelector(selectHasValidGBAccounts);
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const shouldOpenPickerRef = useRef(false);
    const handleAddAccount = useCallback(() => {
        shouldOpenPickerRef.current = true;
        Keyboard.dismiss();
        navigation.navigate('ChooseBank', {
            back: true,
            personalOnly: true,
        });
    }, []);
    const handleChooseOBAccount = useCallback(() => {
        Keyboard.dismiss();
        shouldOpenPickerRef.current = false;
        setIsPickerOpen(true);
        SelectFundingAccountModal.show({
            onSelected: (selectedAccount) => {
                setFrom(selectedAccount);
            },
            onScroll,
            scrollValue,
            onDidHideCallback: () => {
                setIsPickerOpen(false);
            },
        });
    }, [onScroll, scrollValue, setFrom]);
    useEffect(() => {
        if (hasValidGBAccounts && shouldOpenPickerRef.current) {
            handleChooseOBAccount();
        }
    }, [hasValidGBAccounts, handleChooseOBAccount]);
    return (<>
      {!hasValidGBAccounts && (<View style={styles.noAccountsContainer}>
          <Text TextThin-16 Secondary>
            To deposit, you need to connect a bank account that supports Open Banking. This will become your Funding
            account, used for all future deposits and withdrawals.
          </Text>
        </View>)}
      <TouchableBounceCard onDark noMarginTop noMarginBottom style={styles.cardBtn} disabled={!hasValidGBAccounts} onPress={handleChooseOBAccount}>
        <View style={styles.row}>
          <View style={styles.iconContainer}>
            <IconBank gradientKey="lightPurple"/>
          </View>
          <Spacer w={16}/>
          <View style={styles.flex}>
            <Text Text-16 numberOfLines={1}>
              Funding account
            </Text>
          </View>
          {hasValidGBAccounts ? (<IconArrow direction={isPickerOpen ? 'up' : 'down'}/>) : (<Button square small hug brandReversed title="Add" onPress={handleAddAccount}/>)}
        </View>
      </TouchableBounceCard>
    </>);
};
const styleSet = createStyleSheets((colors) => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: rem(44),
        height: rem(44),
        alignItems: 'center',
        borderRadius: rem(22),
        justifyContent: 'center',
        backgroundColor: colors.background.dark,
    },
    flex: {
        flex: 1,
    },
    noAccountsContainer: {
        paddingBottom: rem(16),
        paddingHorizontal: rem(16),
    },
}));
export default memo(FundingAccountRow);
